<template>
    <div class="batch-header" >
      <div class="">
        <div class="row batch-nav">
          <div class="col-sm-2"></div>
          <div class="col-sm-2"><router-link :to="`/batches/ultralocal.ul_file_uploads?bfed_batch_id=`+this.batch_id" style="display:block; padding: 10px;">Summary</router-link></div>
          <div class="col-sm-2 dropdown">
            <button id="om_drop" class="dropbtn">Office Matching</button>
            <div class="dropdown-content">
              <router-link :to="`/ultralocal/ultralocal.ul_office_matching_selection?bfed_batch_id=`+this.batch_id">Match Offices With Suggestions</router-link>
              <router-link :to="`/ultralocal/ultralocal.ul_office_matching_dropdown?bfed_batch_id=`+this.batch_id">Match Offices With Dropdown</router-link>
              <router-link :to="`/ultralocal/ultralocal.ul_office_matching?bfed_batch_id=`+this.batch_id">Match Offices With Table Lookup</router-link>
              <router-link :to="'/ultralocal/ultralocal.ul_offices_creation_dropdown?bfed_batch_id='+this.batch_id">Create UL Offices With Dropdown</router-link>
              <router-link :to="'/ultralocal/ultralocal.ul_offices_creation_workflow?bfed_batch_id='+this.batch_id">Create UL Offices With Lookup</router-link>
            </div>
          </div>
          <div class="col-sm-2 dropdown">
            <button id="error_drop" class="dropbtn">Error Processing</button>
            <div class="dropdown-content">
              <router-link :to="`/tables/ultralocal.ul_bfed_contests?bfed_batch_id=`+this.batch_id">Contest Errors</router-link>
              <router-link :to="`/tables/ultralocal.ul_bfed_candidates?bfed_batch_id=`+this.batch_id">Candidate Errors</router-link>
            </div>
          </div>
          <div class="col-sm-2 dropdown">
            <button id="promote_drop" class="dropbtn">Promote to Gold</button>
            <div class="dropdown-content">
              <router-link :to="`/tables/ultralocal.ul_bfed_promote_to_gold_workflow?bfed_batch_id=`+this.batch_id">Promote to Gold</router-link>
              <router-link :to="`/tables/ultralocal.ul_bfed_page_creation_workflow?bfed_batch_id=`+this.batch_id">Page Creation</router-link>
            </div>
          </div>
        </div>
      </div>
    </div>

</template>

<script>

export default {
    name: 'ULNavHeader',
    methods: {
    },
    props: { batch_id: {type: String, default: ''} },
  }
  </script>
  
  
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
  <style scoped>
 .batch-header {
  background: rgb(51, 122, 183);
  max-width: 99%
}
.batch-header > div { 
  max-width: 99%
}
.batch-nav {
  padding: 10px 0px;
  font-size: 1.3em;
  color: #fff;
}
.batch-nav a {
  color: #fff;
}
.batch-nav .link-inactive {
  color: #555;
}
.batch-nav .active a  {
 color: #000;
}

/* Dropdown Button */
.dropbtn {
  background: rgb(51, 122, 183);
  color: white;
  padding: 10px;
  border: none;
}

/* The container <div> - needed to position the dropdown content */
.dropdown {
  position: relative;
  display: inline-block;
}

/* Dropdown Content (Hidden by Default) */
.dropdown-content {
  display: none;
  position: absolute;
  background-color: #f1f1f1;
  min-width: 160px;
  box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.2);
  z-index: 1;
}

/* Links inside the dropdown */
.dropdown-content a {
  color: black;
  padding: 12px 16px;
  text-decoration: none;
  display: block;
}

/* Change color of dropdown links on hover */
.dropdown-content a:hover {background-color: #ddd;}

/* Show the dropdown menu on hover */
.dropdown:hover .dropdown-content {display: block;  z-index: 1000; }

/* Change the background color of the dropdown button when the dropdown content is shown */
.dropdown:hover .dropbtn {background-color: rgb(34, 96, 151);}

  </style>